/*
 * Access to `localStorage` for the few pieces of browser state the portal keeps there: the
 * colour scheme and the login address (ADR-076 point 2). Callers take the narrow types below, so
 * tests pass a map and a blocked storage is a value, not a crash.
 */

export type ReadableStorage = Pick<Storage, "getItem">;
export type WritableStorage = Pick<Storage, "setItem" | "removeItem">;

/** localStorage, or null where the accessor itself throws (blocked site data). */
export function browserStorage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}
